import React from 'react';
import { i18n as I18n } from 'utils/i18n';
import Textbox from '../../textbox';

const AddressLineOneField = ({ error, ...props }) => {
  return (
    <Textbox
      label={I18n.t('registration.company_details.fields.address1.label')}
      name="address1"
      placeholder={I18n.t('registration.company_details.fields.address1.label')}
      error={!!error}
      errorMsg={error}
      className="input--address-line-one"
      {...props}
    />
  );
};

export default AddressLineOneField;
